import { Component, OnInit, NgZone, ViewContainerRef, ViewChild, ComponentFactoryResolver, TemplateRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { trigger,state,style,transition,animate,keyframes } from    '@angular/animations';
import {AspConfirmOrderPopupComponent} from '../asp-confirm-order-popup/asp-confirm-order-popup.component';
import {AspPaymentService} from './asp-payment.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { GlobalVariable } from '../../../main/globals';
import { AspSwitchGarageService } from '../asp-switch-garage/asp-switch-garage.service';
import { AspCartService } from "../asp-cart/asp-cart.service";
// import {MatBottomSheet} from '@angular/material/bottom-sheet';
// import { AspShippingChargesBottomSheetComponent } from "../asp-shipping-charges-bottom-sheet/asp-shipping-charges-bottom-sheet.component";
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AspSlotDeliveryService } from '../asp-slot-delivery/asp-slot-delivery.service';
import { Location } from '@angular/common';
import { AspLoginService } from '../asp-login/asp-login.service';
declare var Razorpay: any;

@Component({
  selector: 'app-asp-payment',
  templateUrl: './asp-payment.component.html',
  styleUrls: ['./asp-payment.component.scss'],
  animations: [
    trigger('shakeit', [
        state('shakestart', style({
            transform: 'scale(1)',
        })),
        state('shakeend', style({
            transform: 'scale(1)',
        })),
        transition('shakestart => shakeend', animate('1000ms ease-in',     keyframes([
          style({transform: 'translate3d(-1px, 0, 0)', offset: 0.1}),
          style({transform: 'translate3d(2px, 0, 0)', offset: 0.2}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.3}),
          style({transform: 'translate3d(4px, 0, 0)', offset: 0.4}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.5}),
          style({transform: 'translate3d(4px, 0, 0)', offset: 0.6}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.7}),
          style({transform: 'translate3d(2px, 0, 0)', offset: 0.8}),
          style({transform: 'translate3d(-1px, 0, 0)', offset: 0.9}),
        ]))),
  ])]
})
export class AspPaymentComponent implements OnInit, AfterViewInit {
  loading: boolean = false;
  paymentMethod = '';
  paymentButtonText = '';
  states = {};
  shippingAddress = '';
  billingAddress = '';
  cartList = [];
  cartSubTotal = 0;
  sparesDiscount = 0;
  cartGrandTotal = 0;
  shippingAddressId: any;
  billingAddressId:any;
  orderKey: any = '';
  initiatedPayment:boolean = false;
  userDetails: any = [];
  spareSelectedGarageName: any;
  shippingChargesApplicable: any;
  shippingCharges: any;
  isShippingCharges: any;
  prepayUpiDiscount: any;
  autoverseLogo = '../../assets/images/logos/pitstop-white.png'
  walletChecked: boolean = false;
  walletData: any;
  walletAmountToUse: number = 0;
  avoidShippingCharges: any;
  make1: any;
  model1: any;
  year1: any;
  variant1: any;
  fuelType: any;
  registrationNumber: any;
  variantKey: any;
   roleType: string;
  cartGrandTotal1: any;
  isPopupVisible: boolean;
  message: any;
  messageHeading: any;
  createOrderErr: boolean;
  errorMsg: boolean;
  paymentError: boolean;
  showTooltip = false;

allocatedCredit = 300000;
availableCredit = 205303;
  autoverseCredit: any;
  showRegistrationPopup: boolean = false;
  showBottomSheet: boolean = false;
  registrationNumberInput: any;
  regNumberError: string;
  registrationPopupData: any = {};
registrationBottomSheetData: any = {};
regForm: FormGroup = this.fb.group({
  registrationNumber: ['', [this.registrationFormatValidator()]]
});
  data: any;
  redeemPayment: string;
  slotData: any;
  slotid: string;
  slotName: string;
  freeShipping: boolean;



  constructor(    
    private router: Router,
    private zone: NgZone,
    public dialog: MatDialog,
    private aspPaymentService: AspPaymentService,
    private toastr: ToastrService,    
    private aspSwitchGarageService: AspSwitchGarageService,
    private aspCartService: AspCartService,
    // private _bottomSheet: MatBottomSheet,
    private resolver: ComponentFactoryResolver,
    private bottomSheet: MatBottomSheet,
    private cdr: ChangeDetectorRef,
    private aspLoadingService: AspLoadingService,
    private fb: FormBuilder,
    private aspSlotDeliveryService: AspSlotDeliveryService,
     private location: Location,
     public loginService: AspLoginService,
    
  ) { 
    this.states['shake'] = 'shakestart';
  }
 
  ngOnInit(): void { 
    this.roleType = localStorage.getItem('roleType');
    this.slotName=localStorage.getItem("slotName")
    this.redeemPayment=localStorage.getItem("redeemCart");
     if(localStorage.getItem('instantOrderPay')== 'true'){
    this.data=JSON.parse(sessionStorage.getItem('instantOrder'))
      const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;
      cartCountEl.style.display = 'none';
    }else{
      this.data=JSON.parse(sessionStorage.getItem('orderData'))
    } 

   let spareLoginToken = localStorage.getItem('spareLoginToken');
    if(spareLoginToken){
      this.roleType = localStorage.getItem('roleType');
    }
    
    this.getCart();  
    this.cardeails();  
    this.getUser();  
    this.getUserDetails();
   
    if(this.redeemPayment=='true'){
      localStorage.removeItem("slotid");
       localStorage.removeItem("slotName");
       localStorage.removeItem("slotWarehouseName");
      //  this.getWalletData()
    }else{
      this.getSlots();
    }
    this.isShippingCharges = localStorage.getItem("isShippingCharges");
    this.prepayUpiDiscount = localStorage.getItem("prepayUpiDiscount");
    // this.zone.run(() => {
    //   this.dialog.open(AspConfirmOrderPopupComponent);
    // });
    this.getWalletData();
  }
  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;
  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;

  ngAfterViewInit() {
    this.loadingMsg();
    this.cdr.detectChanges();
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
    
  }
  cardeails(){
    let data = this.data;
    // console.log("this.JSON.parse",data)
    // Initialize the flag to check if all variantKeys are the same
    let allVariantKeysAreEqual = true;
    let firstVariantKey: string = '';
    
    data.forEach(cart => {
      Object.entries(cart).forEach(([key, cartitem]) => {
        
        // Check if the variantKey is the same as the first one
        if (firstVariantKey === '') {
          firstVariantKey = cartitem['variantKey'];
        } else if (firstVariantKey !== cartitem['variantKey']) {
          allVariantKeysAreEqual = false;
        }
    
        if (allVariantKeysAreEqual) {
          this.make1 = cartitem['selectedMake'];
          this.model1 = cartitem['selectedModel'];
          this.year1 = cartitem['selectedYear'];
          this.variant1 = cartitem['variant'];
          this.fuelType = cartitem['selectedFuel'];
          this.registrationNumber = cartitem['registrationNumber'];
          this.variantKey = cartitem['variantKey'];
        } else {
          // If variantKey is different, reset values
          this.make1 = '';
          this.model1 = '';
          this.year1 = '';
          this.variant1 = '';
          this.fuelType = '';
          this.registrationNumber ='';
        }
      });
    });
  }
  
  
  loadingMsg() {
    
    const factory = this.resolver.resolveComponentFactory(AspLoadingComponent);
    
   
  
    if (this.containers) {
      const componentRef = this.containers.createComponent(factory);
      
  
      const componentBInstance = componentRef.instance as AspLoadingComponent;
      componentBInstance.getLoadingMsg();
    } else {
      console.error('containers is undefined');
    }
  }
  
  scroll(el: HTMLElement) {
    el.scrollIntoView();
    this.shakeMe('shake');
  }

  shakeMe(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
  this.states[stateVar] = 'shakeend';
  }

  getUser(){      
    this.aspLoadingService.show();   
    let garageKey = localStorage.getItem('garageKey');
    this.aspPaymentService.getUserDetails(garageKey).subscribe(
      res => {
        this.aspLoadingService.hide();
        // let res = JSON.parse(JSON.stringify(result)); 
        if(res['code']==200){
          Object.values(res['data']).forEach(address => { 
            if(address['addressType']=='billing'){
              this.billingAddress = address['address']+", "+address['city']+", "+address['state']+" "+address['pincode'];
              this.billingAddressId = address['id'];
            }
            
            if(address['addressType']=='shipping'){
              this.shippingAddress = address['address']+", "+address['city']+", "+address['state']+" "+address['pincode'];
              this.shippingAddressId = address['id'];
            }
          });
        }
      }
    );
  }

  getUserDetails(){ 
    let spareUserKey = localStorage.getItem('spareUserKey');
    this.aspSwitchGarageService.getUserDetails(spareUserKey).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code && res.code==200){
          this.userDetails['username'] = res.data.name;
          this.userDetails['user_mobile'] = res.data.mobile;
          this.userDetails['user_email'] = res.data.email;
          this.registrationPopupData = res.data.registrationNumberMissingImageData || {};
        this.registrationBottomSheetData = res.data.registrationNumberFillDetails || {};
        }else{
          this.toastr.success(res.message, 'Error');
        }
      }
    );
  }

  getPaymentMode(paymentMode){
    this.paymentMethod = paymentMode;
    if(paymentMode=="2"){
      this.paymentButtonText = 'Proceed To Pay';
    }else if (paymentMode=="1"){
      this.paymentButtonText = 'Confirm Order';
    }
     else {
        this.paymentButtonText = 'Confirm Order';
      }
  }

  getCart(){
    if(this.data){    
      let cartData;  
      this.cartList = [];
      this.cartSubTotal = 0;
      this.sparesDiscount = 0;
      cartData = this.data;
      Object.values(cartData[0]).forEach(cart => { 
        // this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        // this.sparesDiscount += (cart['discount']*cart['cart_qty']);
        this.cartSubTotal += cart['mrp'] * cart['cart_qty'];
        this.sparesDiscount +=
          (cart['mrp'] - cart['sellingPrice']) * cart['cart_qty'];
        
        this.cartList.push(cart);
      });

      if(this.sparesDiscount>0){
        this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
      }else{
        this.cartGrandTotal = this.cartSubTotal;
      }

      // if(this.walletAmountToUse>0){
      //   this.cartGrandTotal = (this.cartGrandTotal - this.walletAmountToUse)
      // }

      if(this.isShippingCharges=='true'){
        this.getShippingCharges();
      }
    }
    // this.getShippingCharges();
  }


  confirmOrder(paymentMethod){
    if(paymentMethod==1 ){
      this.codPayment();
    }else if(paymentMethod==2){
      let orderKey = '';
      let razorPayPaymentId = '';
      this.createOrder(razorPayPaymentId, orderKey, false); 
      // this.razorPayPayment();   
    }else if(paymentMethod==8){
      this.initiatedPayment = true;
    let razorPayPaymentId = '';
    let orderKey = '';
    this.createOrder(razorPayPaymentId, orderKey, false);
    }
    
  }
// confirmOrder(paymentMethod: number) {
//   // Get registration number from localStorage
//   const regNo = localStorage.getItem('registrationNumber');

//   // Check if it's missing or empty
//   if (!regNo || regNo.trim() === '' || regNo === 'null') {
//     this.showRegistrationPopup = true;
//     return; // Stop further processing
//   }

//   // Continue with your payment logic
//   if (paymentMethod === 1) {
//     this.codPayment();
//   } else if (paymentMethod === 2) {
//     const orderKey = '';
//     const razorPayPaymentId = '';
//     this.createOrder(razorPayPaymentId, orderKey, false);
//   } else if (paymentMethod === 8) {
//     this.initiatedPayment = true;
//     const orderKey = '';
//     const razorPayPaymentId = '';
//     this.createOrder(razorPayPaymentId, orderKey, false);
//   }
// }

  // COD Payment - Pitstop
  codPayment(){
    this.initiatedPayment = true;
    let razorPayPaymentId = '';
    let orderKey = '';
    
    if(this.redeemPayment=='true'){
    this.paymentMethod='1';
    }
    this.createOrder(razorPayPaymentId, orderKey, true);
  }

  // Create RazorPay order
  createRazorPayOrder(orderKey){    
    this.aspLoadingService.show();     
    this.initiatedPayment = true;
    // this.cartGrandTotal = 1;

    
    
    let grandTotal = parseInt((this.cartGrandTotal*100).toFixed(0),10);
    let userKey = localStorage.getItem('spareUserKey');
    let userType = localStorage.getItem('userType');
    let garageKey = localStorage.getItem('garageKey');
    let agentKey = localStorage.getItem('agentKey');
    let orderType = 'spare';
    this.aspPaymentService.createRazorPayOrder(orderKey, userKey, garageKey, grandTotal, orderType, userType, agentKey).subscribe(
      result => {
        // this.aspLoadingService.hide(); 
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          let orderKey = res.data.orderKey;
          let razorpayOrder = JSON.parse(res.data.order);
          let razorPayOrderId = razorpayOrder.id;
          this.razorPayPayment(orderKey, razorPayOrderId);
        }else{
          this.aspLoadingService.hide();
          this.router.navigate(['home']);
          this.toastr.error(res.message, 'Error');
        }
      }
    );
  }

  // Initiate Razorpay Payment
  razorPayPayment(orderKey, razorPayOrderId){
    this.aspLoadingService.show();
    this.orderKey = orderKey;
    let grandTotal = this.cartGrandTotal;
    const options = {
      key: GlobalVariable.RAZORPAY_ID,
      amount: parseInt((grandTotal*100).toFixed(0),10),
      name: 'Autoverse Mobility Pvt Ltd',
      image: this.autoverseLogo,
      description: 'Payment for spares purchase',
      currency: 'INR',
      order_id: razorPayOrderId,
      prefill: {
          name: this.userDetails['username'],
          email: this.userDetails['user_email'],
          contact: this.userDetails['user_mobile']
      },
      notes: {
          // order_id: orderId,
          type: 'spare',
          order_key: orderKey,
          // order_number: orderNumber,
          notes: 'Payment for spares purchase',
      },
      theme: {
          color: '#144579'
      },
modal: {
  ondismiss: () => {
    
    this.zone.run(() => {
        this.aspLoadingService.hide();
      this.message = "Your payment could not be processed. Order could not be created.";
      this.messageHeading = "Payment is Failed";
      this.paymentError = true;
      this.isPopupVisible = true;
    });
  }

  },
      handler: this.paymentResponseHandler.bind(this)
  };

  const rzp = new Razorpay(options);
  // rzp.on('payment.failed', (response: any) => {
  //   console.log('error12')
  //    this.message="Your payment could not be processed.Order could not be created.";
  //         this.messageHeading="Payment is Failed";
  //         this.isPopupVisible=true;
  //         this.paymentError=true;
  //     // this.aspLoadingService.hide();
  //         // this.router.navigate(['home']);
  //         // this.toastr.error(res.message, 'Error');
  //   });
  rzp.open();
  }

  // Razorpay success/failure handler
  paymentResponseHandler(response) { 

      // this.aspLoadingService.hide();
    if(response.razorpay_payment_id){      
      // this.dialog.open(AspConfirmOrderPopupComponent);
      let razorPayPaymentId = response.razorpay_payment_id;
      let razorPayOrderId = response.razorpay_order_id;
      let razorPaySignature = response.razorpay_signature;
      this.verifyPayment(razorPayPaymentId, razorPayOrderId, razorPaySignature, this.orderKey);
    }else{
      this.aspLoadingService.hide(); 
      this.orderKey = '';
      this.toastr.error('Payment Failed', 'Error');
      // window.location.href = '/payment/failure/membership/' + this.membershipKey;
    }
  }

  // Verify Razorpay Payment
  verifyPayment(razorPayPaymentId, razorPayOrderId, razorPaySignature, orderKey){
    
    // this.aspLoadingService.show(); 
    let garageKey = localStorage.getItem('garageKey');
    let userKey = localStorage.getItem('spareUserKey');
    let userName = localStorage.getItem('contactName');
    this.aspPaymentService.verifyPayment(razorPayPaymentId, razorPayOrderId, razorPaySignature, orderKey, garageKey,userKey, userName).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        
    this.aspLoadingService.hide(); 
        if(res.code==200){
          // this.createOrder(razorPayPaymentId, orderKey, false);
          if(localStorage.getItem('instantOrderPay')== 'true'){
          const requestItemIds = Object.values(this.data[0]) // access the first object inside the array
          .map(item => item['requestItemId']) // extract requestItemId
          .join(','); // join as comma-separated string

        // console.log(requestItemIds); // Example: "9960,9959,...."


          this.aspPaymentService.updateSpareRequestSalesOrder(requestItemIds, res.data.orderNumber).subscribe(
              response => {
                // console.log('Success:', response);
                 this.zone.run(() => {
            this.dialog.open(AspConfirmOrderPopupComponent);
          });
              },
              error => {
                console.error('Error:', error);
              }
            );
          }else{
            
          this.zone.run(() => {
            this.dialog.open(AspConfirmOrderPopupComponent);
          });
          }
        }else{
           this.message=res.data.description;
          this.messageHeading=res.message;
          // this.router.navigate(['home']);
          // this.toastr.error(res.message, 'Error');
          this.isPopupVisible=true;
          this.paymentError=true;
        }
      }
    );
  }

  // Create Order - Pitstop (RazorPay Flow)
  // createOrder(razorPayPaymentId, orderKey, type){
  //   this.aspLoadingService.show(); 
  //   // if(this.walletChecked && this.walletAmountToUse>0){
  //   //   this.cartGrandTotal = (this.cartGrandTotal - this.walletAmountToUse);
  //   // }

  //   let grandTotal = parseInt((this.cartGrandTotal*100).toFixed(0),10);
  //   this.aspPaymentService.createOrder(this.shippingAddressId, this.billingAddressId, this.paymentMethod, razorPayPaymentId, orderKey, type, grandTotal, this.walletAmountToUse, this.walletChecked).subscribe(
  //     result => {
  //       let res = JSON.parse(JSON.stringify(result)); 
  //       this.aspLoadingService.hide();
  //       if(res.code==200){
  //         this.aspLoadingService.hide();
  //         console.log("rescreate",res)
  //         if(this.paymentMethod=='2'){
  //             this.createRazorPayOrder(res.data.orderKey);
  //         }
  //         sessionStorage.setItem('order', JSON.stringify(res.data));
  //         if(this.paymentMethod=='1' || this.paymentMethod=='8'){
  //           this.zone.run(() => {
  //             this.dialog.open(AspConfirmOrderPopupComponent);
  //           });
  //         }
  //       }else{
  //         this.message=res.data.description;
  //         this.messageHeading=res.message;
  //         if(this.messageHeading=="Credit Limit Exceeded"){
  //         this.createOrderErr=true;
  //         this.isPopupVisible=true;
  //         }
  //          if(this.messageHeading=="Error 400"){
  //         this.errorMsg=true;
  //         this.isPopupVisible=true;
  //         }
  //         // this.router.navigate(['home']);
  //         // this.toastr.error(res.message, 'Error');
  //       }
  //     }
  //   );
  // }
  createOrder(razorPayPaymentId, orderKey, type) {
    

    if (!this.showRegistrationPopup && !(this.redeemPayment =='true')) {
      // console.log('this.showRegistrationPopup',this.showRegistrationPopup)
      // const regNo = this.registrationNumber;
      // console.log('this.registrationNumber',this.registrationNumber)
      // if (!regNo || regNo.trim() === '' || regNo === 'null' ) {
      //   this.showRegistrationPopup = true;
      //   return;
      // }
      let regNo = this.registrationNumber || '';
      if (!regNo) {
        const cart = JSON.parse(localStorage.getItem('addedCart') || '[]');
        regNo = (Object.values(cart[0] || {}) as any[])
          .find(i => i?.registrationNumber)?.registrationNumber;
      }
      if (!regNo || regNo === 'null' || regNo.trim() === '') {
        this.showRegistrationPopup = true;
        return;
      }
    } else {
      this.showRegistrationPopup = false;
      this.showBottomSheet = false;
    }

    this.aspLoadingService.show(); 
    let instructionData: any = {};
    const rawData = localStorage.getItem('orderInstructions');

    if (rawData) {
      try {
        // ✅ if it's proper JSON
        instructionData = JSON.parse(rawData);
      } catch {
        // ⚠️ fallback for OLD string format
        instructionData = {
          garageDiscount: Number(rawData.match(/Garage Discount %: (\d+)/)?.[1]) || 0,
          preferredDeliveryMode: rawData.match(/Preferred Delivery Mode: ([^|]+)/)?.[1]?.trim() || '',
          additionalNotes: rawData.match(/Additional Notes: (.*)/)?.[1]?.trim() || ''
        };
      }
    }

    // ✅ build payload
    const orderInstructionsPayload = {
      garageDiscount: instructionData?.garageDiscount ?? 0.0,
      preferredDeliveryMode: instructionData?.preferredDeliveryMode ?? '',
      additionalNotes: instructionData?.additionalNotes ?? ''
    };

    let grandTotal = parseInt((this.cartGrandTotal * 100).toFixed(0), 10);

    this.aspPaymentService.createOrder(
      this.shippingAddressId,
      this.billingAddressId,
      this.paymentMethod,
      razorPayPaymentId,
      orderKey,
      type,
      grandTotal,
      this.walletAmountToUse,
      this.walletChecked,
      orderInstructionsPayload
    ).subscribe(result => {
      let res = JSON.parse(JSON.stringify(result)); 
      this.aspLoadingService.hide();

      if (res.code == 200) {
        // console.log("rescreate", res);
        localStorage.removeItem("orderInstructions");

        if (this.paymentMethod == '2') {
          this.createRazorPayOrder(res.data.orderKey);
        }

        sessionStorage.setItem('order', JSON.stringify(res.data));

        // =================CALLING UPDATE ORDER STATUS API===============

        const orderKey = res.data.orderKey;
        const requestCartInfo = JSON.parse(
          localStorage.getItem('requestCartInfo') || '{}'
        );

        // const requestId = requestCartInfo.requestId;
        const requestId =  requestCartInfo.requestId ||  localStorage.getItem('requestId') ||    null;

        const itemIds = requestCartInfo.itemIds;

        console.log('================ UPDATE SALES CHECK ================');
        console.log('orderKey:', orderKey);
        console.log('requestId:', requestId);
        console.log('itemIds:', itemIds);
        console.log('requestCartInfo:', requestCartInfo);

        if (orderKey && requestId && itemIds) {

          console.log('Calling updateSalesOrder API...');

          this.aspPaymentService
            .updateSalesOrder(orderKey, requestId, itemIds)
            .subscribe({
              next: (response) => {
                console.log('================ UPDATE SALES SUCCESS ================');
                console.log(response);
              },
              error: (err) => {
                console.log('================ UPDATE SALES FAILED ================');
                console.error(err);
              }
            });

        } else {

          console.log('================ UPDATE SALES NOT CALLED ================');
          console.log({
            orderKey,
            requestId,
            itemIds
          });

        }
        
        if (this.paymentMethod == '1' || this.paymentMethod == '8') {
          if(localStorage.getItem('instantOrderPay')== 'true'){
          const requestItemIds = Object.values(this.data[0]) // access the first object inside the array
          .map(item => item['requestItemId']) // extract requestItemId
          .join(','); // join as comma-separated string

        // console.log(requestItemIds); // Example: "9960,9959,...."


            this.aspPaymentService.updateSpareRequestSalesOrder(requestItemIds, res.data.orderNumber).subscribe(
            response => {
              // console.log('Success:', response);
                this.zone.run(() => {
                this.dialog.open(AspConfirmOrderPopupComponent);
          });
            },
            error => {
              console.error('Error:', error);
            }
          );
            }else{
              this.zone.run(() => {
              this.dialog.open(AspConfirmOrderPopupComponent);
            });
            }
        
          }
      } else {
            if (res.code == 403) {
          this.loginService.logout();
          return;
        }
        this.message = res.data.description;
        this.messageHeading = res.message;

        if (this.messageHeading == "Credit Limit Exceeded") {
          this.createOrderErr = true;
          this.isPopupVisible = true;
        }

        if (this.messageHeading == "Error 400") {
          this.errorMsg = true;
          this.isPopupVisible = true;
        }
      }
    });
  }

  toggleWalletCheckbox() {
    // console.log("cartGrandTotal",this.cartGrandTotal);
    this.walletChecked = !this.walletChecked;
    // Add your wallet toggle logic here


    // If checkbox is checked, subtract wallet amount; otherwise, reset it
    if(this.redeemPayment=='true'){
  if (this.walletChecked) {
    this.calculateRedeemWalletAmountToUse(); // Recalculate wallet amount to use
  } else {
    this.walletAmountToUse = 0; // Reset the wallet amount to use if unchecked
  }
}else{
  if (this.walletChecked) {
    this.calculateWalletAmountToUse(); // Recalculate wallet amount to use
  } else {
    this.walletAmountToUse = 0; // Reset the wallet amount to use if unchecked
  }
  
}
  
    if(this.walletChecked && this.walletAmountToUse>0){
      this.cartGrandTotal1 = this.cartGrandTotal;
      this.cartGrandTotal = (this.cartGrandTotal - this.walletAmountToUse);
    }else{
      this.cartGrandTotal = this.cartGrandTotal1;
    }
    
  }
  // Bottom sheet open
  shippingChargesBottomSheet(){
    // this._bottomSheet.open(AspShippingChargesBottomSheetComponent);
  }

  // Shipping charges
  getShippingCharges(){    
    this.aspLoadingService.show();  
    let garageKey = localStorage.getItem('garageKey');
    // console.log("cartGrandTotal",this.cartGrandTotal);
    this.aspCartService.getShippingCharges(this.cartGrandTotal, garageKey).subscribe(
      result => {
       this.getWalletData()
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.aspLoadingService.hide();
          // if(this.shippingChargesApplicable && this.cartSubTotal<=this.avoidShippingCharges){
          if(this.slotName=="Instant Delivery"){
            this.cartGrandTotal = (this.cartGrandTotal+this.shippingCharges);
            this.cartGrandTotal1=(this.cartGrandTotal+this.shippingCharges);
          }
          if(this.slotName=='pickPick Up From StoreUp'){
            this.cartGrandTotal = (this.cartGrandTotal+this.slotData?.wareHouseData[0].shippingCharges);
            this.cartGrandTotal1=(this.cartGrandTotal+this.slotData?.wareHouseData[0].shippingCharges);
          }if(this.slotName=='Smart Slot Delivery'){
            this.cartGrandTotal = (this.cartGrandTotal+this.slotData?.currentSlot.shippingCharges);
            this.cartGrandTotal1=(this.cartGrandTotal+this.slotData?.currentSlot.shippingCharges);
          }
         } else {
          // console.log("Unexpected response code:", res.code);  // Log if the response code is not 200
        }
      }
    );
  }

  getWalletData() {
    const garageKey = localStorage.getItem('garageKey');
    const userKey = localStorage.getItem('spareUserKey');

    this.aspPaymentService.getWallet(garageKey,userKey).subscribe(
      res => {
        if (res['code'] === 200) {
          this.walletData = res['data']; 
          this.autoverseCredit=this.walletData.autoverseCredit;
          if(this.redeemPayment=='true'){
            
             this.toggleWalletCheckbox();
          }else{
          if(this.walletData?.wallet?.isWallet==true && this.walletData?.wallet?.walletAmount>0){
            this.toggleWalletCheckbox();
          }else{
          this.calculateWalletAmountToUse(); 
          }
        }
        } else {
          this.toastr.error(res['message'], 'Error');
        }
      },
      err => {
        this.toastr.error('Failed to load payment methods', 'Error');
      }
    );
  }
  calculateWalletAmountToUse() {
    if (this.walletData && this.walletData.wallet && this.walletData.wallet.isWallet) {
      const balance = this.walletData.wallet.walletAmount;
      const percentageValue = this.walletData.wallet.walletRule.value;
      const maximumValue = this.walletData.wallet.walletRule.maximum;

      // Calculate 10% of the wallet balance
      const calculatedAmount = (balance * percentageValue) / 100;

      // Ensure it doesn't exceed the maximum allowed value
      
      if(Math.min(calculatedAmount, maximumValue)>=this.cartGrandTotal){
        this.walletAmountToUse = this.cartGrandTotal;
      }else{
        this.walletAmountToUse = Math.min(calculatedAmount, maximumValue);
      }
    }
  }
  calculateRedeemWalletAmountToUse() {
  if (this.walletData && this.walletData.wallet && this.walletData.wallet.isWallet) {
    const balance = this.walletData.wallet.walletAmount;

    // Use full wallet balance, but not more than the cart total
    this.walletAmountToUse = Math.min(balance, this.cartGrandTotal);
  }
}

  openBottomSheet(): void {
    // this.bottomSheet.open(this.bottomSheetTemplate,{
    //  panelClass: 'custom-bottom-sheet1'
    // }
    // );
    this.freeShipping=true;
  }
  closeShipping(){
     this.freeShipping=false;
  }

  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
 closePopup(){
  this.isPopupVisible=false;
  this.errorMsg=false;
  this.initiatedPayment=false;
  this.showBottomSheet = false;
  this.showRegistrationPopup = false;
 }
 makePayment(){
  this.isPopupVisible=false;
  if(this.createOrderErr==true){
    this.createOrderErr=false;
    this.router.navigate(['payment-collection']);
  }
  
 }
addRegistrationNumber() {
  this.showBottomSheet = true;
  this.showRegistrationPopup = false;
}
closeRegistrationNumber(){
    this.showRegistrationPopup = false;
    this.showBottomSheet = false;
}

validateRegNumber() {
  const value = this.registrationNumberInput.trim();
  if (!value || value.length < 6) {
    this.regNumberError = 'Please enter a valid registration number.';
  } else {
    this.regNumberError = '';
  }
}

// saveRegistrationNumber() {
//   const control = this.regForm.get('registrationNumber');
//   const value = control?.value?.trim();

//   if (!value) {
//     this.showBottomSheet = false;
//     return;
//   }

//   if (control?.invalid) {
//     control.markAsTouched();
//     return;
//   }

//   // Store cleaned registration number (without spaces)
//   const cleanedValue = value.replace(/\s+/g, '').toUpperCase();
//   localStorage.setItem('registrationNumber', cleanedValue);

//   this.showBottomSheet = false;

//   // Now call createOrder with `+this.paymentMethod` to convert to number
//   const razorPayPaymentId = '';
//   const orderKey = '';
//   const type = '';
//   console.log('Calling createOrder with paymentMethod:', this.paymentMethod);

//   this.createOrder(razorPayPaymentId, orderKey, type);
// }
saveRegistrationNumber() {

  const control = this.regForm.get('registrationNumber');
  const value = control?.value?.trim();

  if (!value) {
    control?.setErrors({ required: true });
    control?.markAsTouched();
    return;
  }

  if (control?.invalid) {
    control.markAsTouched();
    return;
  }

  const cleanedValue = value.replace(/\s+/g, '').toUpperCase();
  localStorage.setItem('registrationNumber', cleanedValue);
  this.registrationNumber=cleanedValue;

  this.showBottomSheet = false;

  const razorPayPaymentId = '';
  const orderKey = '';
  const type = '';
  // console.log('Calling createOrder with paymentMethod:', this.paymentMethod);

  this.createOrder(razorPayPaymentId, orderKey, type);
}


bindRegistrationFormatWatcher() {
  const control = this.regForm.get('registrationNumber');
  if (control) {
    control.valueChanges.subscribe(value => {
      const formatted = this.formatRegNo(value);
      if (value !== formatted) {
        control.setValue(formatted, { emitEvent: false });
      }
    });
  }
}
formatRegNo(value: string): string {
  value = value.replace(/\s+/g, '').toUpperCase();
  let formatted = '';
  if (value.length > 0) formatted += value.slice(0, 2);
  if (value.length > 2) formatted += ' ' + value.slice(2, 4);
  if (value.length > 4) formatted += ' ' + value.slice(4, 6);
  if (value.length > 6) formatted += ' ' + value.slice(6);
  return formatted.trim();
}

registrationFormatValidator(): ValidatorFn {
 return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const cleaned = value.replace(/\s+/g, '').toUpperCase();

    // Validate length >= 1
    if (cleaned.length >= 1) {
      return null; // valid
    }

    return { invalidFormat: true }; // invalid if empty
  };
}
onRegistrationInput(event: any): void {
  const input = event.target;
  let raw = input.value.replace(/\s+/g, '').toUpperCase();

  let formatted = '';
  if (raw.length > 0) formatted += raw.slice(0, 2);
  if (raw.length > 2) formatted += ' ' + raw.slice(2, 4);
  if (raw.length > 4) formatted += ' ' + raw.slice(4, 6);
  if (raw.length > 6) formatted += ' ' + raw.slice(6, 10);

  this.regForm.get('registrationNumber')?.setValue(formatted, { emitEvent: false });

  // Move cursor to end
  setTimeout(() => {
    input.selectionStart = input.selectionEnd = formatted.length;
  });
}
illDoLater() {
  localStorage.setItem('registrationNumber', 'NA');
  this.createOrder('', '', '');
  this.showBottomSheet = false;
}

 getSlots(){
    let dataRaw;
 if(localStorage.getItem('instantOrderPay')== 'true'){
    dataRaw=sessionStorage.getItem('instantOrder')
      const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;
      cartCountEl.style.display = 'none';
    }else{
      dataRaw=sessionStorage.getItem('orderData')
    } 

    const parsed = JSON.parse(dataRaw); // Parse the full JSON string

    const partKeysArray = Object.keys(parsed[0]);
    this.aspLoadingService.show();
      this.aspSlotDeliveryService.getSlotData(partKeysArray).subscribe(
        res => {
          if(res['code']==200){
          this.aspLoadingService.hide();
          this.slotData=res['data'];
        // console.log("res", res);
          }else{
            
          // this.toastr.error(res['message'], 'Error');
          }
          
      
    this.getShippingCharges();
      });


  }
    getDeliveryLabel(date): string {
    const now = new Date();
    const deliveryDate = new Date(date);

    // Strip time for comparison
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const deliveryDay = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());

    const diffInTime = deliveryDay.getTime() - today.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    const time = deliveryDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (diffInDays === 0) {
      return `Today by ${time}`;
    } else if (diffInDays === 1) {
      return `Tomorrow by ${time}`;
    } else {
      return `On ${deliveryDate.toLocaleDateString()} by ${time}`;
    }
  }
getUpcoming(dateString: string): string {
  const now = new Date();
  const deliveryDate = new Date(dateString);

  // Strip time for comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const deliveryDay = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());

  const diffInDays = (deliveryDay.getTime() - today.getTime()) / (1000 * 3600 * 24);

  const hours = deliveryDate.getHours();
  const minutes = deliveryDate.getMinutes();

  const isPM = hours >= 12;
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
  const timeFormatted = `${hour12}:${minutesFormatted} ${isPM ? 'PM' : 'AM'}`;

  if (diffInDays === 0) {
    return `Today ${timeFormatted}`;
  } else if (diffInDays === 1) {
    return `Tomorrow ${timeFormatted}`;
  } else {
    const dateFormatted = deliveryDate.toLocaleDateString(); // You can customize this
    return `${dateFormatted} ${timeFormatted}`;
  }
}
goToSlot(){
  this.router.navigate(['slot']);
}

convertMinutesToTimeLabel(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const h = hours > 0 ? `${hours}h` : '';
  const m = minutes > 0 ? `${minutes}m` : '';

  return `${h} ${m}`.trim(); // Removes extra space if minutes = 0
}
switchToSmartSlot(){
this.router.navigate(['slot'], {
  state: {
    isSelected: true,
    slotId: 1
  }
});

}
openMap(): void {
  const lat = this.slotData.wareHouseData[0].latitude ;
  const lng = this.slotData.wareHouseData[0].longitude ;

  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;

  window.open(mapsUrl, '_blank');
}
    goBack(): void {
      this.location.back();
  }
}

